module.exports = __webpack_public_path__ + "img/inviter@2x.0f2b2fdb.png";